
















































import {
  Vue,
  Component,
  Prop,
} from "@/shared/vuepack";
import _ from "lodash";
import { Location } from "vue-router";
import moment from "moment-timezone";
import ProposedScheduleTable from "@/shared/components/contributionsV3/ProposedScheduleTable.vue";
import ContributionConfirmationModal from "@/shared/components/contributionsV3/ContributionConfirmationModal.vue";
import { TransferSchedule } from "@/shared/types";
import { Contribution, OnboardingContributionScheduledMessage } from "@/employee/route-names";
import { usePersonalContributionSchedulesStore } from "@/shared/store/personalContributionSchedules";
import { useNotifierStore } from "@/shared/store/notifier";
import { getScheduleDescription } from "@/employee/Utilities/TransferScheduleUtility";
import { formatMMMDateString } from "@/shared/dateString";
import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";

@Component({
  components: {
    ProposedScheduleTable,
    ContributionConfirmationModal
  }
})
export default class ConfirmContributionPage extends Vue {
  personalContributionScheduleStore = usePersonalContributionSchedulesStore();
  notifierStore = useNotifierStore();
  custodianSettingsStore = useCustodianSettingsStore();

  @Prop()
  schedule: TransferSchedule;

  @Prop()
  page: number;

  @Prop()
  updating: boolean;

  @Prop()
  routeToModifySchedule: (schedule: TransferSchedule) => Location;

  @Prop()
  isOnboarding: boolean;

  isSubmitting = false;
  confirmModalVisible = false;

  mounted (): void {
    if (!this.schedule) {
      this.$router.replace({ name: Contribution });
    }
  }

  get portalFunctionalityDisabled (): boolean {
    return this.custodianSettingsStore.portalFunctionalityDisabled;
  }

  get scheduleText (): string {
    let description = getScheduleDescription(this.schedule);
    if (this.schedule.scheduleEndDate) {
      description += ` from ${formatMMMDateString(this.schedule.scheduleStartDate)} to ${formatMMMDateString(this.schedule.scheduleEndDate)}`;
    } else {
      description += ` starting on ${formatMMMDateString(this.schedule.scheduleStartDate)}`;
    }

    return `Your recurring contribution schedule is set up for ${description}. Here's when your contributions will be posted:`;
  }

  onConfirm () {
    this.isSubmitting = true;
    this.confirmModalVisible = true;
  }

  onCancel () {
    this.$router.replace(this.routeToModifySchedule(this.schedule));
  }

  onSkip () {
    this.$emit("skip");
  }

  onModalConfirm (): void {
    if (this.portalFunctionalityDisabled) {
      return;
    }

    const model = _.cloneDeep(this.schedule);
    model.userConfirmationDate = moment.utc().toISOString();
    if (this.updating) {
      this.personalContributionScheduleStore.updatePersonalContributionSchedule(model)
        .then(() => {
          this.notifierStore.setSuccess("Your personal contribution schedule has been updated.");
        })
        .finally(() => {
          this.submitComplete();
        });
    } else {
      this.personalContributionScheduleStore.createPersonalContributionSchedule(model)
        .then(() => {
          this.notifierStore.setSuccess("Your personal contribution schedule has been created.");
        })
        .finally(() => {
          this.submitComplete();
        });
    }
  }

  submitComplete () {
    this.confirmModalVisible = false;
    this.isSubmitting = false;
    if (this.isOnboarding) {
      this.$router.push({
        name: OnboardingContributionScheduledMessage
      });
    } else {
      this.$router.push({ name: Contribution, query: { tab: "schedules"} });
    }
  }

  onModalCancel () {
    this.confirmModalVisible = false;
    this.isSubmitting = false;
  }
}
